import { SxProps, Theme } from "@mui/material/styles";

import { Link } from "components/Link";
import { Paragraph } from "components/Paragraph";

type Props = {
  techSheetUrl?: string;
  style?: SxProps<Theme>;
};

export const ProductTechSheet = ({ techSheetUrl, style }: Props) => {
  if (!techSheetUrl) return null;
  return (
    <Link to={techSheetUrl} external noMargin>
      <Paragraph
        style={{
          ...style,
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
        }}
        ellipsis
        disableSelect
      >
        Ver ficha técnica
      </Paragraph>
    </Link>
  );
};
